export function isErrorWith(errors: { [key: string]: string }, fieldName: string) {
  return !!errors[fieldName]
}
